import React from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import PropertyCard from '@molecules/PropertyCard';
import PropertyListItem from '@molecules/PropertyListItem';

// Functionality
import usePropertyMatchFilters from '../../../hooks/algoliaFilters/usePropertyMatchFilters';
import { SAVED_PROPERTIES_QUERY } from '@general/graphql/properties.graph';
import { mapSearchPropertyToProps } from '@general/transforms/property.transform';

const SearchMyPropertyMatches = ({
    savedSearch,
    additionalFilters,
    hitsPerPage,
    parentView,
    displayFilters = false,
    displayPagingToolbar = false,
    displaySearchBox = false,
    displaySearchOptions = false,
    NoResultsText,
}) => {
    const { filters, optionalFilters } = usePropertyMatchFilters({
        savedSearches: [savedSearch],
        additionalFilters,
        excludeOptionalFilters: false,
    });

    return (
        <Search
            index="properties"
            hitsPerPage={hitsPerPage}
            displayFilters={displayFilters}
            displayPagingToolbar={displayPagingToolbar}
            displaySearchBox={displaySearchBox}
            displaySearchOptions={displaySearchOptions}
            filters={filters}
            optionalFilters={optionalFilters}
        >
            <SearchResults
                cardComponent={props => <PropertyCard openInNewTab {...props} />}
                index="properties"
                listItemComponent={PropertyListItem}
                parentView={parentView}
                query={SAVED_PROPERTIES_QUERY}
                resultsPerRow={3}
                transformFunc={mapSearchPropertyToProps}
                typePlural="savedProperties"
                NoResultsText={NoResultsText}
            />
        </Search>
    );
};

SearchMyPropertyMatches.propTypes = {
    savedSearch: PropTypes.object.isRequired,
    additionalFilters: PropTypes.string,
    displayFilters: PropTypes.bool,
    displayPagingToolbar: PropTypes.bool,
    displaySearchBox: PropTypes.bool,
    displaySearchOptions: PropTypes.bool,
    hitsPerPage: PropTypes.number,
    parentView: PropTypes.string,
    NoResultsText: PropTypes.elementType,
};

export default SearchMyPropertyMatches;
